import { Box } from "@mui/system";
import React from "react";

const ContentLayout = ({ children }) => {
  return (
    <Box
      id="content-layout"
      style={{
        display: "grid",
        flexGrow: 1,
        gridTemplateRows: "auto 1fr auto",
        height: "100vh",
        width: "100%",
      }}
    >
      {children}
    </Box>
  );
};

export default ContentLayout;
